import styled from 'styled-components'
import {Link} from '@components/lib'

import ContentBox from 'components/ContentBox'

export const Container = styled(ContentBox)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
`

export const TextBold = styled.span`
  color: ${({theme}) => theme.colors.textThird};
  font-weight: 500;
`

export const Text = styled.div`
  font-size: ${({theme}) => theme.fontSizes.small};

  ${({theme}) => theme.breakpoints.down('laptop')} {
    font-size: ${({theme}) => theme.fontSizes.medium};
  }

  ${({theme}) => theme.breakpoints.down('tabletS')} {
    font-size: ${({theme}) => theme.fontSizes.small};
  }
`

export const MfaLink = styled(Link)``
